// extracted by mini-css-extract-plugin
module.exports = {"GalleryList":"GalleryList_GalleryList__3GfrS","noData":"GalleryList_noData__-6jXy","btn_back":"GalleryList_btn_back__2L5Y5"};